import openNotification from "./CustomNotification";
let errorHandled = false;

export const resetGlobalErrorFlag = () => {
  errorHandled = false;
};

export const handleGlobalError = (message: string) => {
  if (!errorHandled) {
    errorHandled = true;
    openNotification({
      type: "error",
      message,
    });
  }
};
